import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { IIrwinAttributes } from "src/app/_interfaces/irwin/IIrwinAttributes";
import { IrwinAttributeUpdaterService } from "src/app/_services/incident/irwin/irwin-attribute-updater.service";
import { IrwinSearchService } from "src/app/_services/incident/irwin/irwin-search.service";
import { IrwinToolPresentationComponent } from "../irwin-tool-presentation/irwin-tool-presentation.component";

@Component({
    selector: "wfdss-irwin-tool-smart",
    templateUrl: "./irwin-tool-smart.component.html",
    styleUrls: ["./irwin-tool-smart.component.scss"],
    standalone: false
})
export class IrwinToolSmartComponent implements OnInit {
  @ViewChild("errorDialog") errorDialog: HTMLDialogElement;
  @ViewChild("presentation") presentationComponent: IrwinToolPresentationComponent;

  constructor(
    private irwinSearchService: IrwinSearchService,
    private irwinAttributeUpdaterService: IrwinAttributeUpdaterService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  irwinDataToDisplay: Partial<IIrwinAttributes>;
  irwinId: string;
  fullIrwinJson: string;

  irwinPushError: string;

  queryParamsSubscription: Subscription;

  ngOnInit() {
    this.queryParamsSubscription = this.route.queryParams.subscribe(
      (queryParams) => {
        if (queryParams.irwinId !== this.irwinId) {
          this.fetchIrwinData(queryParams.irwinId);
        }
      }
    );
  }

  ngOnDestroy() {
    this.queryParamsSubscription?.unsubscribe();
  }

  handleNewIrwinIdSearch(irwinId: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        irwinId,
      },
    });
  }

  fetchIrwinData(irwinId: string) {
    this.irwinSearchService
      .getIrwinIncident(irwinId, true)
      .subscribe((IrwinData) => {
        if (IrwinData?.attributes) {
          //@ts-ignore
          this.irwinDataToDisplay = IrwinData.attributes;
          this.irwinId = this.irwinDataToDisplay.IrwinID;
          this.presentationComponent.dialogTextAreaValue = JSON.stringify(this.irwinDataToDisplay, null, 2);
        } else {
          alert(
            "An error occurred fetching data from IRWIN: \n" +
              JSON.stringify(IrwinData, null, 2)
          );
        }
      });
  }

  handleFullIrwinJsonFetch(irwinId: string) {
    const cleanId = irwinId?.replace(/\{|\}/g, '').toLowerCase();
    if (!cleanId) {
      this.presentationComponent.dialogTextAreaValue = "No IRWIN ID provided.";
      return;
    }

    this.presentationComponent.dialogTextAreaValue = "Loading Full IRWIN JSON...";

    this.irwinSearchService.getRawFullIrwinIncident(cleanId, false)
    .subscribe({
      next: (rawJson: string) => {
        this.presentationComponent.dialogTextAreaValue = this.formatRawJson(rawJson);                                                                   
      },
      error: (error) => {
        this.presentationComponent.dialogTextAreaValue = `An error occurred fetching full IRWIN JSON data: \n ${JSON.stringify(error, null, 2)}`;
      }
    });
  }

  private formatRawJson(jsonString: string): string {
    return JSON.stringify(JSON.parse(jsonString.trim()), null, 2);
  }


  handleAttributePushRequest(AttributeKeyvaluePair) {
    this.irwinPushError = "";

    this.irwinAttributeUpdaterService
      .pushIrwinAttribute(
        this.irwinId,
        AttributeKeyvaluePair.key,
        AttributeKeyvaluePair.value
      )
      .subscribe((returnedValue) => {
        if (returnedValue?.updateResults?.[0]?.attributes) {
          this.irwinDataToDisplay.IrwinID = this.irwinDataToDisplay.IrwinID?.replace(/\{|\}/g, ''); // IRWIN ID could come with opening and closing curly braces
          this.irwinId = this.irwinDataToDisplay.IrwinID;
          this.irwinDataToDisplay = returnedValue.updateResults[0].attributes;
        } else {
          this.irwinPushError =
            `An IRWIN error occurred updating ${AttributeKeyvaluePair.key} to ${AttributeKeyvaluePair.value}: \n` +
            JSON.stringify(returnedValue, null, 2);
          //@ts-ignore
          this.errorDialog.nativeElement.showModal();
        }
      });
  }

  handleAttributesPushRequest(attributes) {
    this.irwinAttributeUpdaterService
      .pushIrwinAttributes(this.irwinId, attributes)
      .subscribe((returnedValue) => {
        if (returnedValue?.updateResults?.[0]?.attributes) {
          this.irwinId = this.irwinDataToDisplay.IrwinID;
          this.irwinDataToDisplay = returnedValue.updateResults[0].attributes;
        } else {
          this.irwinPushError =
            `An IRWIN error occurred updating irwin Values: \n` +
            JSON.stringify(returnedValue, null, 2);
          //@ts-ignore
          this.errorDialog.nativeElement.showModal();
        }
      });
  }
}
